export default __webpack_public_path__ + "static/media/pain-points.b1416967.svg";